import React, { useCallback, useState } from 'react';
import { View, ScrollView, RefreshControl, TouchableOpacity } from 'react-native';
import { useTheme, Images } from '@config';
import { SafeAreaView, Icon, Text, Image } from '@components';
import styles from './styles';
import { connect } from 'react-redux';
import { BaseColor, BaseStyle } from '../../config';
import { useFocusEffect } from '@react-navigation/native';
import { Button, Header, TextInput } from '../../components';
import * as SplashScreen from 'expo-splash-screen';
import { userActions } from '../../redux/actions';
import UserListItem from '../../components/UserListItem';
import Menu from '../../components/Menu';

function UserList({ getUserAuth, getAllUser, allUser, navigation }) {
    const { colors } = useTheme();
    const [state, setState] = useState({ searchValue: "", statusFilter: null, sort: 0 });
    const searchUsers =
        allUser.count > 0
            ? allUser.rows
                .filter(
                    (user) =>
                        JSON.stringify(user)
                            .toLowerCase()
                            .includes((state.searchValue ?? '').toLowerCase()) &&
                        (state.statusFilter == null
                            ? true
                            : user.roles[0]?.value == state.statusFilter)
                )
                .sort((a, b) => {
                    return state.sort == 1
                        ? a.firstname?.toString()?.localeCompare(b.firstname?.toString()) :
                        state.sort == 2
                            ? a.lastname?.toString()?.localeCompare(b.lastname?.toString())
                            : state.sort == 3
                            && a.id?.toString()?.localeCompare(b.id?.toString())
                })
            : [];

    useFocusEffect(
        useCallback(() => {
            getUserAuth();
            onRefresh();
        }, [])
    );

    const onRefresh = () => {
        getAllUser('');
    };

    const searchText = (searchValue) => {
        setState((s) => ({ ...s, searchValue }));
    };

    const filterAction = () => (
        <View>
            <Menu
                activator={() => (
                    <View style={{ padding: 10, borderRadius: 13, backgroundColor: BaseColor.grayLight }}>
                        <Icon name="sort-ascending" type="mci" size={20} color={BaseColor.text} />
                    </View>
                )}
                title={"Sortieren nach"}
                actionItems={[
                    {
                        text: 'Id',
                        action: () => {
                            setState((s) => ({ ...s, sort: 0 }));
                        },
                        leftIcon: () => (
                            <View
                                style={{
                                    backgroundColor: BaseColor.grayLight,
                                    height: 45,
                                    borderRadius: 15,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            ></View>
                        ),
                        rightIcon:
                            state.sort == 0
                                ? () => (
                                    <View
                                        style={{
                                            //backgroundColor: BaseColor.grayLight,
                                            height: 45,
                                            borderRadius: 15,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Icon name="check" type="ad" size={20} color={BaseColor.primary} />
                                    </View>
                                )
                                : null,
                    },
                    {
                        text: 'Vorname',
                        action: () => {
                            setState((s) => ({ ...s, sort: 1 }));
                        },
                        leftIcon: () => (
                            <View
                                style={{
                                    backgroundColor: BaseColor.grayLight,
                                    height: 45,
                                    borderRadius: 15,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            ></View>
                        ),
                        rightIcon:
                            state.sort == 1
                                ? () => (
                                    <View
                                        style={{
                                            //backgroundColor: BaseColor.grayLight,
                                            height: 45,
                                            borderRadius: 15,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Icon name="check" type="ad" size={20} color={BaseColor.primary} />
                                    </View>
                                )
                                : null,
                    },
                    {
                        text: 'Nachname',
                        action: () => {
                            setState((s) => ({ ...s, sort: 2 }));
                        },
                        leftIcon: () => (
                            <View
                                style={{
                                    backgroundColor: BaseColor.grayLight,
                                    height: 45,
                                    borderRadius: 15,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            ></View>
                        ),
                        rightIcon:
                            state.sort == 2
                                ? () => (
                                    <View
                                        style={{
                                            //backgroundColor: BaseColor.grayLight,
                                            height: 45,
                                            borderRadius: 15,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Icon name="check" type="ad" size={20} color={BaseColor.primary} />
                                    </View>
                                )
                                : null,
                    },
                ]}
            />
        </View>
    );

    const renderList = () => {
        let list = (
            <View style={{ padding: 15 }}>
                {[1, 2, 3, 4, 5, 6].map((item, index) => {
                    return (
                        <View key={`ClientListItem ${index}`} style={{ width: '100%', paddingBottom: 20 }}>
                            <UserListItem loading={true} />
                        </View>
                    );
                })}
            </View>
        );
        if (searchUsers?.length >= 0) {
            list = (
                <View style={{ padding: 0 }}>
                    {searchUsers.map((item, index) => {
                        return (
                            <View key={`ClientListItem ${item?.id}`}>
                                <UserListItem navigation={navigation} item={item} />
                            </View>
                        );
                    })}
                </View>
            );
        }

        return <View style={{ paddingBottom: 80 }}>{list}</View>;
    };
    const onLayoutRootView = useCallback(async () => {
        await SplashScreen.hideAsync();
    }, []);
    const renderContent = () => {
        return (
            <View style={{ flex: 1 }} onLayout={onLayoutRootView}>
                <Header
                    title="Alle Benutzer"
                    //shadow
                    renderLeft={() => {
                        return <Icon name="arrowleft" size={25} type="ad" enableRTL={true} />;
                    }}
                    onPressLeft={() => {
                        navigation.goBack();
                    }}
                />
                <ScrollView
                    style={{ flex: 1, backgroundColor: BaseColor.whiteColor }}
                    stickyHeaderIndices={[1]}
                    refreshControl={<RefreshControl colors={[colors.primary]} tintColor={colors.primary} refreshing={false} onRefresh={onRefresh} />}
                >
                    <View style={{ flexDirection: 'row', paddingTop: 20, paddingHorizontal: 15 }}>
                        <View style={{ flex: 1 }}>
                            <TextInput
                                onChangeText={searchText}
                                placeholder="Suchen..."
                                value={state.searchValue}
                                style={{ height: 40, }}
                                icon={
                                    state.searchValue ? (
                                        <TouchableOpacity onPress={() => searchText('')} style={{ padding: 5, }}>
                                            <Icon name="times" type="mui" size={20} color={BaseColor.text} />
                                        </TouchableOpacity>
                                    ) : (
                                        <Icon name="search" type="ft" size={20} color={BaseColor.text} />
                                    )
                                }
                            />
                        </View>
                        <View style={{ paddingLeft: 10, alignItems: 'center', justifyContent: 'center' }}>{filterAction()}</View>
                    </View>
                    <View>
                        <View style={{
                            flexDirection: 'row', paddingTop: 10, paddingHorizontal: 15, backgroundColor: '#fff', borderBottomColor: BaseColor.grayTransparent,
                            borderBottomWidth: 1,
                        }}>
                            <View>
                                <TouchableOpacity
                                    style={{
                                        //backgroundColor: BaseColor.grayLight,
                                        height: 40,
                                        paddingHorizontal: 3,
                                        //borderRadius: 20,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderBottomWidth: 2,
                                        borderColor: state.statusFilter == null ? BaseColor.primary : "#fff",
                                    }}
                                    onPress={() => setState((s) => ({ ...s, statusFilter: null }))}
                                >
                                    <View>
                                        <Text semibold>Alle</Text>
                                    </View>
                                </TouchableOpacity>
                            </View>
                            <View style={{ flex: 1 }}>
                                <TouchableOpacity
                                    style={{
                                        // backgroundColor: BaseColor.grayLight,
                                        height: 40,
                                        //borderRadius: 20,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderBottomWidth: 2,
                                        borderColor: state.statusFilter == 3 ? BaseColor.primary : "#fff",
                                    }}
                                    onPress={() => setState((s) => ({ ...s, statusFilter: 3 }))}
                                >
                                    <View>
                                        <Text semibold>ADM</Text>
                                    </View>
                                </TouchableOpacity>
                            </View>
                            <View style={{ flex: 1 }}>
                                <TouchableOpacity
                                    style={{
                                        // backgroundColor: BaseColor.grayLight,
                                        height: 40,
                                        //borderRadius: 20,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderBottomWidth: 2,
                                        borderColor: state.statusFilter == 2 ? BaseColor.primary : "#fff",
                                    }}
                                    onPress={() => setState((s) => ({ ...s, statusFilter: 2 }))}
                                >
                                    <View>
                                        <Text semibold>Kunde</Text>
                                    </View>
                                </TouchableOpacity>
                            </View>
                            <View style={{ flex: 1 }}>
                                <TouchableOpacity
                                    style={{
                                        //backgroundColor: BaseColor.grayLight,
                                        height: 40,
                                        //borderRadius: 20,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderBottomWidth: 2,
                                        borderColor: state.statusFilter == 1 ? BaseColor.primary : "#fff",
                                    }}
                                    onPress={() => setState((s) => ({ ...s, statusFilter: 1 }))}
                                >
                                    <View>
                                        <Text semibold>Projektleiter</Text>
                                    </View>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                    {renderList()}
                </ScrollView>
            </View>
        );
    };

    return (
        <SafeAreaView style={[BaseStyle.safeAreaView]} edges={['right', 'left']}>
            {renderContent()}
            <View style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                <View style={{ padding: 20, alignItems: 'center', justifyContent: 'center' }}>
                    <Button
                        style={{ height: 40, backgroundColor: 'white' }}
                        textColor={'black'}
                        icon={<Icon name="plus" size={25} type="ad" color={BaseColor.primary} />}
                        onPress={() => navigation.navigate('UserNew')}
                    >
                        {' '}
                        Benutzer hinzufügen
                    </Button>
                </View>
            </View>
        </SafeAreaView>
    );
}

function mapState(state) {
    const { user, all } = state.users;
    return { allUser: all, user };
}

const actionCreators = {
    getUserAuth: userActions.getUserAuth,
    getAllUser: userActions.getAll,
    deleteAction: userActions.delete,
};

export default connect(mapState, actionCreators)(UserList);
